(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bizafrika-contact-bar"] && !Shopify.designMode) return;
  try {
    
  const initializeBizAfrikaLiveChat = () => {
    const mount = document.querySelector('[data-bizafrika-live-chat]');
    const marketingAllowed = document.documentElement?.dataset.bizafrikaMarketingConsent === 'yes';
    if (!mount || !marketingAllowed || document.querySelector('script[data-widget-id="6a9916d198f3179f2ea6a791"]')) return;
    const script = document.createElement('script');
    script.src = 'https://widgets.leadconnectorhq.com/loader.js';
    script.dataset.resourcesUrl = 'https://widgets.leadconnectorhq.com/chat-widget/loader.js';
    script.dataset.widgetId = '6a9916d198f3179f2ea6a791';
    script.async = true;
    document.body.appendChild(script);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeBizAfrikaLiveChat, { once: true });
  } else {
    initializeBizAfrikaLiveChat();
  }
  document.addEventListener('bizafrika:privacy-state', event => {
    if (event.detail?.marketing === true) initializeBizAfrikaLiveChat();
  });
  document.addEventListener('shopify:section:load', initializeBizAfrikaLiveChat);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bizafrika-home-enquiry"] && !Shopify.designMode) return;
  try {
    
  if (!document.querySelector('script[src="https://link.msgsndr.com/js/form_embed.js"]')) {
    const helper = document.createElement('script');
    helper.src = 'https://link.msgsndr.com/js/form_embed.js';
    helper.defer = true;
    document.body.appendChild(helper);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bizafrika-linkedin-posts"] && !Shopify.designMode) return;
  try {
    
  const initializeBizAfrikaLinkedIn = () => {
    const allowedPosts = new Set(['ugcPost:7453125942853558272', 'ugcPost:7402326865077530626', 'ugcPost:7396487068685701120', 'share:7384562728083914752']);
    document.querySelectorAll('[data-ba-linkedin]').forEach(root => {
      if (root.dataset.initialized === 'true') return;
      const toggle = root.querySelector('[data-linkedin-toggle]');
      if (!toggle) return;
      root.dataset.initialized = 'true';
      let requested = true;
      let marketingAllowed = document.documentElement?.dataset.bizafrikaMarketingConsent === 'yes';
      const updateLinkedInFrames = () => {
        root.querySelectorAll('[data-linkedin-frame]').forEach(frame => {
          const placeholder = frame.parentElement.querySelector('[data-linkedin-placeholder]');
          let valid = false;
          try {
            const url = new URL(frame.dataset.embedUrl);
            const id = url.pathname.replace('/embed/feed/update/urn:li:', '');
            valid = url.origin === 'https://www.linkedin.com' && allowedPosts.has(id) && !url.search && !url.hash && !url.username && !url.password;
          } catch (_) {
            valid = false;
          }
          if (requested && marketingAllowed && valid) {
            frame.src = frame.dataset.embedUrl;
            frame.hidden = false;
            if (placeholder) placeholder.hidden = true;
          } else {
            frame.removeAttribute('src');
            frame.hidden = true;
            if (placeholder) placeholder.hidden = false;
          }
        });
        toggle.setAttribute('aria-expanded', String(requested && marketingAllowed));
        toggle.textContent = marketingAllowed
          ? (requested ? toggle.dataset.hideLabel : toggle.dataset.showLabel)
          : toggle.dataset.consentLabel;
      };
      toggle.addEventListener('click', () => {
        if (!marketingAllowed) {
          const banner = document.querySelector('[data-bizafrika-consent]');
          if (banner) {
            banner.hidden = false;
            banner.querySelector('[data-bizafrika-consent-accept]')?.focus();
          }
          return;
        }
        requested = !requested;
        updateLinkedInFrames();
      });
      document.addEventListener('bizafrika:privacy-state', event => {
        marketingAllowed = event.detail?.marketing === true;
        updateLinkedInFrames();
      });
      updateLinkedInFrames();
      toggle.hidden = false;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeBizAfrikaLinkedIn, { once: true });
  else initializeBizAfrikaLinkedIn();
  document.addEventListener('shopify:section:load', initializeBizAfrikaLinkedIn);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
